import { ExcelExportSheetConfig } from "../types";

/** Retail Excel export sheet definitions — add excelSheet entries here. */
export const retailExcelExportSheets: ExcelExportSheetConfig[] = [];
